import React from "react";
import { useWatchState } from "@/store";
//import HZ from "./hz";
import Thtt from "./thtt";
import { platformDic } from "@/dic";
import "./style.less";

function Isefc() {
  const [[PLATFORM]] = useWatchState(["PLATFORM"]);

  const Content = {
 //   [platformDic.HZ.value]: HZ,
    [platformDic.THTT.value]: Thtt,
  }[PLATFORM];

  return <Content />;
}

export default Isefc;